import React from 'react';
import './ShareableLinksDownloadFlow.scss';
import {Box, Typography} from '@mui/material';
import {ReactComponent as DownloadGradient} from '../../../../assets/images/download_bg.svg';
import {ReactComponent as DownloadErrorIcon} from '../../../../assets/images/download-error.svg';
import {t} from 'i18next';

interface DownloadErrorProps {
  isLinkExpired: boolean;
}

const DownloadError: React.FC<DownloadErrorProps> = ({
  isLinkExpired = false,
}) => {
  return (
    <Box className="shareable-links-container">
      <Box className="download-container">
        <DownloadGradient
          className="download-container-gradient"
          aria-hidden="true"
          focusable="false"
        />
        <Box className="download-error-container">
          <DownloadErrorIcon />
          <Box className="error-msg-container">
            <Typography
              id="download-title"
              data-testid="download-title"
              className="typo-text display2_size download-title"
            >
              {isLinkExpired
                ? t(
                    'productionsAndExports.createNewProduction.downloadLinks.linkExpired'
                  )
                : t(
                    'productionsAndExports.createNewProduction.downloadLinks.error'
                  )}
            </Typography>
            <Typography
              id="download-title"
              data-testid="download-title"
              className="typo-text body1_size error-sub-msg"
            >
              {isLinkExpired
                ? t(
                    'productionsAndExports.createNewProduction.downloadLinks.linkExpiredMsg'
                  )
                : t(
                    'productionsAndExports.createNewProduction.downloadLinks.errorMsg'
                  )}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DownloadError;
